import { render } from "./company-lists-item.vue?vue&type=template&id=5975e0c4&scoped=true&ts=true"
import script from "./company-lists-item.vue?vue&type=script&lang=ts"
export * from "./company-lists-item.vue?vue&type=script&lang=ts"

import "./company-lists-item.vue?vue&type=style&index=0&id=5975e0c4&lang=scss&scoped=true"
import "./company-lists-item.vue?vue&type=style&index=1&id=5975e0c4&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5975e0c4"]])

export default __exports__